<template>
    <div>
    </div>
</template>

<script>
  import {configStatusSubject} from "../webRtcViewer";

  export default {
    name: "ReturnHomeWidget",
    data: () => ({
    }),
    created () {
        // subscribe to config status subject
      this.subscription = configStatusSubject.subscribe({
        next: (configStatus) => {
          // update config status
          if (Object.prototype.hasOwnProperty.call(configStatus, 'returnHomeWidget')) {
            if (Object.prototype.hasOwnProperty.call(configStatus.returnHomeWidget, 'returnHomeState')) {
              this.$store.commit("setReturnHomeState", configStatus.returnHomeWidget.returnHomeState);
            }
          }
        }
      })
    },
    beforeDestroy() {
      this.subscription.unsubscribe()
    },
  }
</script>

<style scoped>

</style>
